import constate from 'constate';
import { GlobalFilter } from '@/plugin-system/runtime/GlobalFilters';

type TablePanelConfigProviderProps = {
  onAddFilters?: (args: GlobalFilter[]) => void;
};
export const [TablePanelConfigProvider, useTablePanelConfigStrict] = constate(
  (props: TablePanelConfigProviderProps) => {
    return props;
  }
);
